import { render, staticRenderFns } from "./PurchaseTypeComponent.vue?vue&type=template&id=5013905a"
import script from "./PurchaseTypeComponent.vue?vue&type=script&lang=ts"
export * from "./PurchaseTypeComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports